import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Table from '@app/components/teachers/Classes/Table'
import ClassesContainer from '@app/containers/teachers/Classes'
import PillsMenu from '@app/components/teachers/PillsMenu'

const Classes = ({ teacher, route }) => {
  return (
    <Fragment>
      <div className="page page__inner mt-2">
        <h1 className="plate-heading plate-heading--left">
          { I18n.t('teachers.show.classes') }
        </h1>
        <ClassesContainer ChildComponent={Table} route={route} />
      </div>
    </Fragment>
  )
}

Classes.propTypes = {
  route: PropTypes.object.isRequired
}

export default Classes

